export default __webpack_public_path__ + "static/media/carousel-5.23f9212e.png";